import React from "react";
import "./Footer.css";
import { FaInstagram, FaEnvelope } from "react-icons/fa"; // Importando os ícones
import logo from "../../images/logo.png";

const Footer = () => {
  return (
    <section className="contato" id="contato">
      <div className="contato-content">
        <div className="logo-footer">
          <img src={logo} alt="Logo" />
        </div>

        <div className="contato-text">
          <h3>Contatos</h3>
          <ul>
            <li>
              <a
                href="https://www.instagram.com/yaracatarina/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram className="social-icon" /> Instagram
              </a>
            </li>
            <li>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=adv.yaracatarina@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="email-link"
              >
                <FaEnvelope className="social-icon" /> adv.yaracatarina@gmail.com
              </a>
            </li>
            <li>
              (91) 9 8598-0703
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <a href="https://wa.me/5547989293394" target="_blank" rel="noreferrer">
          <p> Feito por • João Arthur Lima da Silva </p>
        </a>
      </div>
    </section>
  );
};

export default Footer;
